export default __webpack_public_path__ + "static/media/down.72d0f64d.svg";